var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPictureAsPdf = function SvgPictureAsPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "picture_as_pdf_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#picture_as_pdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M9.712 10.442h1.115q.375 0 .63-.254.255-.255.254-.63V8.442q0-.375-.254-.63a.86.86 0 0 0-.63-.254H9.269a.43.43 0 0 0-.31.133.42.42 0 0 0-.132.309v4q0 .177.133.31a.425.425 0 0 0 .619 0A.42.42 0 0 0 9.71 12zm0-.884V8.442h1.115v1.116zm4.98 2.884q.376 0 .63-.254.255-.255.255-.63V8.442q0-.375-.255-.63a.86.86 0 0 0-.63-.254h-1.519a.42.42 0 0 0-.31.133.42.42 0 0 0-.132.309v4q0 .177.133.31a.42.42 0 0 0 .309.132zm-1.077-.884V8.442h1.077v3.116zm3.962-1.116h.75a.42.42 0 0 0 .31-.133.424.424 0 0 0 0-.618.42.42 0 0 0-.31-.133h-.75V8.442h.75a.42.42 0 0 0 .31-.133.424.424 0 0 0 0-.618.42.42 0 0 0-.31-.133h-1.193a.42.42 0 0 0-.309.133.42.42 0 0 0-.133.309v4q0 .177.133.31a.424.424 0 0 0 .62 0 .42.42 0 0 0 .132-.31zM8.057 17.5q-.756 0-1.282-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T8.058 2.5h11.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h11.385a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V4.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H8.058a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096m-3.5 5q-.756 0-1.282-.525a1.75 1.75 0 0 1-.525-1.283V7.058q0-.319.216-.535a.73.73 0 0 1 .534-.215q.32 0 .535.215a.73.73 0 0 1 .215.535v12.134q0 .116.096.212a.3.3 0 0 0 .212.096h12.134q.319 0 .535.216a.73.73 0 0 1 .215.534q0 .32-.215.535a.73.73 0 0 1-.535.215z"
  }))));
};
export default SvgPictureAsPdf;